<template>
  <div>
    <top-navbar/>
    <slot/>
    <page-footer/>
  </div>
</template>

<script>
import TopNavbar from '@components/shared/TheTopNavbar'
import PageFooter from '@components/shared/TheFooter'

export default {
  components: {
    TopNavbar,
    PageFooter,
  },
  // mounted() {
  //   if (
  //     process.env.NODE_ENV != 'development' &&
  //     this.$route.path != '/instructions/network' &&
  //     !this.isCurrentUrlHttps()
  //   ) {
  //     this.loadHttpsPage()
  //   }
  // },
  // methods: {
  //   loadHttpsPage() {
  //     window.location.href = window.location.href.replace('http', 'https')
  //   },
  //   isCurrentUrlHttps() {
  //     return window.location.href.indexOf('https') >= 0
  //   },
  // },
}
</script>
